var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmitigatedViolations({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#009076",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.247 11.881c.237.058.475.112.718.167.19.043.324.212.323.407v.877c0 .23-.186.417-.416.417H3.537a.417.417 0 0 1-.417-.417v-.88c0-.193.135-.362.324-.405.241-.055.48-.108.71-.167a23.782 23.782 0 0 1 6.05-.84c2.042.02 4.073.302 6.043.841zM19.513 6.731a2.007 2.007 0 0 0-.916-1.275L11.413.381a2.106 2.106 0 0 0-2.416 0L1.83 5.44A2.09 2.09 0 0 0 .888 6.73a2.12 2.12 0 0 0 .275 1.617l1.763 2.288c.1.13.267.189.426.151.175-.04.347-.083.52-.122a24.736 24.736 0 0 1 6.333-.875c2.14.017 4.269.311 6.333.875.174.044.347.083.523.125a.417.417 0 0 0 .422-.153l1.789-2.333a2.083 2.083 0 0 0 .241-1.573zm-7.175-.516c.004.476-.235.921-.633 1.183l-1.308.875a.37.37 0 0 1-.392 0l-1.308-.875a1.426 1.426 0 0 1-.634-1.183V4.323a.34.34 0 0 1 .175-.3 3.493 3.493 0 0 1 3.934 0 .35.35 0 0 1 .166.3v1.892zM16.62 15.035a.408.408 0 0 0-.167-.036h-12.5a.416.416 0 0 0-.172.037 1.623 1.623 0 0 0-.968 1.281c-.062.568.19 1.125.658 1.453a11.285 11.285 0 0 0 13.465 0c.468-.328.72-.885.657-1.453a1.622 1.622 0 0 0-.973-1.282z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmitigatedViolations);
export default __webpack_public_path__ + "static/media/unmitigated-violations.22d735eb419b7f77f22918a3827eb2eb.svg";
export { ForwardRef as ReactComponent };